module.exports = __webpack_public_path__ + "images/file_icons_v2/java-52f972002a6f28b1e54814f8cd402487.svg";